import Acl from '@/services/util/acl';

const AclPlugin = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.mixin({
      methods: {
        can: (rule) => Acl.can(rule),
        canAnd: (rule) => Acl.canAnd(rule),
        acl: () => Acl,
      },
    });

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$acl = () => Acl;

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$can = (role) => Acl.can(role);

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$canAnd = (role) => Acl.canAnd(role);
  },
};

export default AclPlugin;
